module.exports = __webpack_public_path__ + "img/66.b072fa0.png";